'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var RESET_FORM = 'reset-form-completed';

exports.RESET_FORM = RESET_FORM;
